import {HttpHeaders} from '@angular/common/http';

export const appConfig = {
  assetManagementPortalRoot: window['notDev'] ? '/asset-management-portal/#' : '/#',
  siteAdminRoot: '/jsp/onsite-admin-app/#',
  loginFormUrl: '/jsp/acct/login-form.jsp',
  httpOptions: {
    headers: new HttpHeaders({'Content-Type': 'application/json'})
  },
  formHttpOptions: {
    headers: new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'})
  },
  newWindowOptions: 'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,height=1024,width=1280',
  defaultNumberOfDaysToGoBackForGettingAuctionEvents: 720,
  testPublicImageHost: 'https://test-imgproc.ironpla.net/img',
  defaultPhotoUrlForNonPhotoItem: 'https://s.ironpla.net/n_images/logo-bw-1.png',
  defaultPhotoUrlForNonPhotoRBItem: 'https://cdn.ironpla.net/resources/images/rba-photo-na.jpg',
  cdnBaseHref: 'https://www-ironplanet.s3-us-west-2.amazonaws.com/',
  publicImageHostSetFromJsp: window['imagePublicHost'],
  getPublicImageHost() {
    return !!window['imagePublicHost'] ? window['imagePublicHost'] : this.testPublicImageHost;
  },
  dateFormat: 'dd-MMM-yyyy',
  dateTimeFormat: 'dd-MMM-yyyy HH:mm',
  timeFormatWithSeconds: 'HH:mm:ss',
  dateMonthFormat: 'dd MMM',
  monthDateFormat: 'MMMM dd, yyyy h:mm a',
  localeForDateFormat: 'en-US',
  getItemHistoryPageUrl(equipmentId) {
    return '/jsp/equip/equipHistory.jsp?equipId=:equipmentId'.replace(':equipmentId', String(equipmentId));
  },
  ironPlanetItemInfoHref: '/jsp/s/item/',
  getIronPlanetPageUrl() {
    return !!window['ipWebSiteUrl'] ? window['ipWebSiteUrl'] : '';
  },
  getRbAuctionPageUrl() {
    return !!window['rbWebSiteUrl'] ? window['rbWebSiteUrl'] : '';
  },
  getGovPlanetPageUrl: function() {
    return !!window['govWebSiteUrl'] ? window['govWebSiteUrl'] : '';
  },
  getSalvageSalePageUrl: function() {
    return !!window['salvagesaleWebSiteUrl'] ? window['salvagesaleWebSiteUrl'] : '';
  },
  getEventDashboardUrl: function(siteId:number, auctionEventId: number) {
    return `/jsp/onsite-admin-app/#/site-management/sites/${siteId}/events/${auctionEventId}/summary`;
  }
};
